import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import EmptyData from "../../../components/EmptyData";

const FAQPublic = () => {
  const faqs = useSelector((state) => state.meta?.faqs);

  return (
    <>
      <SiteTitle title="سوالات متداول" />

      <div className="card basic-data-table">
        <div className="card-header p-0 border-0">
          <div className="responsive-padding-40-150 bg-light-pink">
            <div className="row gy-4 align-items-center">
              <div className="col-xl-7">
                <h6 className="mb-20">سوالات متداول</h6>
                <p className="mb-0 text-secondary-light max-w-634-px text-sm">
                  موضوع موردنظرتان از دسته‌بندی زیر انتخاب کنید
                </p>
              </div>
              <div className="col-xl-5 d-xl-block d-none">
                <img src="/assets/images/faq-img.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body bg-base responsive-padding-40-150">
          {isEmpty(faqs) ? (
            <EmptyData title="سوالی برای نمایش یافت نشد" />
          ) : (
            <div className="row gy-4">
              <div className="col-lg-4">
                <div
                  className="active-text-tab nav flex-column nav-pills bg-base shadow py-0 px-24 radius-12 border"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  {faqs?.map((item, index) => (
                    <button
                      className={`nav-link text-secondary-light fw-semibold text-xl px-0 py-16 border-bottom ${
                        index === 0 ? "active" : ""
                      }`}
                      id={`${item?._id}-tab`}
                      data-bs-toggle="pill"
                      data-bs-target={`#${item?._id}`}
                      type="button"
                      role="tab"
                      aria-controls={item?._id}
                      aria-selected="true"
                    >
                      {item.title}
                    </button>
                  ))}
                </div>
              </div>
              <div className="col-lg-8">
                <div className="tab-content" id="v-pills-tabContent">
                  {faqs?.map((item, index) => (
                    <div
                      className={`tab-pane fade ${
                        index === 0 ? "show active" : ""
                      }`}
                      id={item?._id}
                      role="tabpanel"
                      aria-labelledby={`${item?._id}-tab`}
                      tabIndex={0}
                    >
                      <div className="accordion" id={`${item?._id}-parent`}>
                        {item?.questions?.map((question, idx) => (
                          <div className="accordion-item" key={question?._id}>
                            <h2 className="accordion-header">
                              <button
                                className="accordion-button text-primary-light text-xl"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#${question?._id}`}
                                aria-expanded="true"
                                aria-controls={question?._id}
                              >
                                {question?.question}
                              </button>
                            </h2>
                            <div
                              id={question?._id}
                              className={`accordion-collapse collapse ${
                                idx === 0 ? "show" : ""
                              }`}
                              data-bs-parent={`#${item?._id}}-parent`}
                            >
                              <div className="accordion-body">
                                {question?.answer}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FAQPublic;
